import logo from "../assets/images/frcsit-logo.png";
import { useLoader } from "../context/LoaderContext";

const Loader = () => {
  const { loading } = useLoader();
  return (
    <>
      {loading && (
        <div className="preloader">
          <img
            className="preloader__image"
            width="250"
            height="100"
            src={logo}
            alt="loader-logo"
          />
        </div>
      )}
    </>
  );
};

export default Loader;
